import { render } from "./couponCenter.vue?vue&type=template&id=300c3760"
import script from "./couponCenter.vue?vue&type=script&lang=js"
export * from "./couponCenter.vue?vue&type=script&lang=js"

import "./couponCenter.vue?vue&type=style&index=0&id=300c3760&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__